export class UserTokenResponseModel {
  public token: string;

  public refresh_token: string;
}
